$(document).ready(function(){
playVedio();
  
  $('.tabs li').click(function(){
  	var tab_id = $(this).attr('data-tab-value');
    alert(tab_id);
     $('.tabs li').removeClass('active');
     $('.tabs-content').removeClass('active');
    $(this).addClass('active');
    $('#'+tab_id).addClass('active');
  });
  
  $('.swiper-wrapper').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
 
    responsive: [
    {
      breakpoint: 1279,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: true,
        variableWidth: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
    
  });
  
  //var owl = $('.jumpflex-wrapper');

  
  
  
   //$('.jumpflex-owners .owl-nav').removeClass('disabled');
  

  
  
  $('.accessories_video').magnificPopup({
    // disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false
  });
  
  $("#product-carousel-gallery").each(function(){
        $(this).magnificPopup({
            delegate:"a.gallery",
            removalDelay:300,
            mainClass:"mfp-fade",
            type:"image",
            gallery:{enabled:!0},
            iframe:{
                patterns:{
                    youtube:{
                        src:"//www.youtube.com/embed/%id%?autoplay=1&rel=0"
                    }
                }
            }
        });
    });
  
  
  
  /* login form js code */
    $("#create_customer").submit(function() {
      	var password = $("#password").val();
        var confirmpassword = $("#confirmpassword").val();
      if(password != confirmpassword){
    	event.preventDefault();
      }
    });
  
  $("#login_submit").click(function(e){ 
    e.preventDefault();
  $("#pop_login_error").html('');
	var frm = $('#customer_login');
        $.ajax({
            type: frm.attr('method'),
            url: frm.attr('action'),
            data: $("#customer_login input").serialize(),
          	success: function (data) {
                if (data.indexOf('Invalid login credentials.') !== -1) {
                  $("#pop_login_error").html('Invalid login credentials.');
                  // invalid password - show a message to the user
                } else if (/checkout_url/.test(self.location.href)) {
				    // Redirect back to the checkout page if the login page url includes string 'checkout_url'
                  window.location.href = '/checkout';
                } else {
                    // All good! Let's redirect if required
                    window.location.href = '/account';
                }
              
            },
            error: function (data) {
                console.log('An error occurred.');
               
            },
        });
    
    });
  $("#register_submit").click(function(e){
    e.preventDefault();
    $("#pop_signup_error").html('');
	var create_customer = $('#create_customer');
    	if ( $('#password').val() != $('#confirmpassword').val()) {
           $("#pop_signup_error").html('Password and Confirm password are not match');
        }else{
		$.ajax({
              type: create_customer.attr('method'),
              url: create_customer.attr('action'),
              data: $("#create_customer input").serialize(),
              success: function (res) {console.log(res);
                  if (res.indexOf("<ul><li>Password can't be blank.</li><li>Email can't be blank.</li></ul>") !== -1) {
                    $("#pop_signup_error").html("<ul><li>Password can't be blank.</li><li>Email can't be blank.</li></ul>");
                    // invalid password - show a message to the user
                  }else if(res.indexOf("Email can't be blank.") !== -1){
                  	$("#pop_signup_error").html("Email can't be blank.");
                  }else if(res.indexOf("Email is invalid.") !== -1){
                  	$("#pop_signup_error").html("Email is invalid.");
                  }else if(res.indexOf("Password is too short (minimum is 5 characters)") !== -1){
                  	$("#pop_signup_error").html("Password is too short (minimum is 5 characters)");
                  }else if(res.indexOf("Password can't be blank.") !== -1){
                  	$("#pop_signup_error").html("Password can't be blank.");
                  } else {
                  // All good! Let's redirect if required
                    window.location.href = '/account';
                  }
            	

              },
              error: function (res) {
                  console.log('An error occurred.');
	
            	
              }
          });
        }
   });
   /* login form js code */
  
 /* $(".aaaformbuilder_form").submit(function(e) {

    e.preventDefault(); // avoid to execute the actual submit of the form.

    var frm = $('.aaaformbuilder_form');
        $.ajax({
            type: frm.attr('method'),
            url: frm.attr('action'),
            data: $(".aaaformbuilder_form input").serialize(), // serializes the form's elements.
           success: function(data)
           {
               $("#ContactFormResponse").show(); // show response from the php script.
             	$('#ContactFormInitial').hide();
           }
         });
});*/
  
});

function playVedio(){
    $(".cb-video-placeholder").on("click", function() {
        var video_id = $(this).attr('id');
      	var video_src = $(this).attr("data-video");
        $('#'+video_id).replaceWith('<div class="video-wrapper"><div class="embed-responsive"><iframe src="//www.youtube.com/embed/' + video_src + '?rel=0&amp;showinfo=0;autoplay=1"><\/iframe></div></div>');
    });
}

